// extracted by mini-css-extract-plugin
export var form = "form-module--form--HG0ZA";
export var postionTitleForm = "form-module--postionTitleForm--2YhEW";
export var inputEmail = "form-module--inputEmail--13POk";
export var checkBox = "form-module--checkBox---zAvL";
export var textBox = "form-module--textBox--2L0sp";
export var textareaMessage = "form-module--textareaMessage--jxFC-";
export var positionButton = "form-module--positionButton--2cAXQ";
export var button = "form-module--button--1_6ik";
export var deactivated = "form-module--deactivated--Z-VOA";